import { render } from "./ResetEmail.vue?vue&type=template&id=8fcbc598&scoped=true&ts=true"
import script from "./ResetEmail.vue?vue&type=script&lang=ts"
export * from "./ResetEmail.vue?vue&type=script&lang=ts"

import "./ResetEmail.vue?vue&type=style&index=0&id=8fcbc598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fcbc598"]])

export default __exports__